var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlertLight = function SvgIconAlertLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_alert_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2 18.6v7.6H23v-7.6h2.2ZM25.2 28.2v3H23v-3h2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 12.346c1.824-3.128 6.276-3.128 8.1 0l.003.004L38.55 30.346l.002.002c1.822 3.127-.397 7.052-4.052 7.052H13.7c-3.654 0-5.873-3.925-4.051-7.052l.001-.002L20.048 12.35l.002-.004Zm1.901 1.107v.001L11.552 31.45l-.003.004A2.479 2.479 0 0 0 13.7 35.2h20.8a2.479 2.479 0 0 0 2.15-3.746l-.002-.004L26.25 13.454l-.001-.002a2.47 2.47 0 0 0-4.298 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_alert_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 10)",
    d: "M0 0h30.2v27.4H0z"
  })))));
};
export default SvgIconAlertLight;